export const StaticLinks = {
  HelpLink: 'https://docs.microsoft.com/partner-center/report-problems-with-partner-center',
  AppointmentDocLink: 'https://docs.microsoft.com/partner-center/schedule-support-appointment',
  DtmUrl: 'https://client.dtmnebula.microsoft.com/msa/home/index?workspaceid=',
  SupportRequestAdminLink: 'https://learn.microsoft.com/partner-center/view-support-requests',
};
